import { Button, DataSource, Label, Layout, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutDecline extends Layout {
    buttonConfirmDecline: Button;
    labelAdditionalDetails: Label;
    labelDeclineOffer: Label;
    labelDeliveryDate: Label;
    labelDeliveryDateTZ: Label;
    labelDistance: Label;
    labelDistanceCaption: Label;
    labelDistanceUnits: Label;
    labelEmailOfferConfirmation: Label;
    labelEquipmentDescr: Textbox;
    labelEquipmentLength: Textbox;
    labelPickupDate: Label;
    labelPickupDateTZ: Label;
    labelSuccess: Label;
    labelThisLoadIsNoLongerAvailable: Label;
    panelAdditionalDetails: Panel;
    panelAvailable: Panel;
    panelCommodityAndEquipment: Panel;
    panelDelivery: Panel;
    panelNotAvailable: Panel;
    panelPickup: Panel;
    panelSuccess: Panel;
    sourceCarrierAvailableOrders: DataSource;
    textboxCommodity: Textbox;
    textboxDestinationLocation: Textbox;
    textboxLTL: Textbox;
    textboxOrderId: Textbox;
    textboxOriginLocation: Textbox;
    textboxRateCurrency: Textbox;
    textboxWeight: Textbox;
}
